import { render, staticRenderFns } from "./Hlb2.vue?vue&type=template&id=1c8e6f22&scoped=true"
import script from "./Hlb2.vue?vue&type=script&lang=js"
export * from "./Hlb2.vue?vue&type=script&lang=js"
import style0 from "./Hlb2.vue?vue&type=style&index=0&id=1c8e6f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e6f22",
  null
  
)

export default component.exports